/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import GlobalSettings from '@/model/global/GlobalSettings'
import StringEntity from '@/model/dataLayer/api/common/StringEntity'

const entity = {
  code: {},
  kitchenBonDelaySec: {
    displayName: 'Minute'
  },
  isActive: {
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      default: true
    }
  },
  langs: {
    displayName: 'SourceMark',
    type: IKDataEntity.Types.Group,
    formConfig: {
      groupName: 'SourceMark',
      default: GlobalSettings.supportLang,
      childLabelKey: 'lang',
      type: {}
    },
    header: false,
    tableConfig: {
      displayCondition: (item) => {
        return item.lang.toUpperCase() === GlobalSettings.getLang().toUpperCase()
      }
    },
    childKey: 'name',
    children: [
      StringEntity, StringEntity, StringEntity
    ]
  }
}
const config = {
  add: function (item) {
    item.kitchenBonDelaySec = 60 * item.kitchenBonDelaySec
    return hillo.post('Complex.php?op=addSourceMarkOption', {
      sourceMarkOption: JSON.stringify(item)
    })
  },
  edit: function (item) {
    item.kitchenBonDelaySec = 60 * item.kitchenBonDelaySec
    item.isActive = item.isActive ? 1 : 0
    return hillo.post('Complex.php?op=updateSourceMarkOption', {
      sourceMarkOption: JSON.stringify(item)
    })
  },
  remove: function (id) {
    return hillo.post('Complex.php?op=removeSourceMarkOption', { id })
  },
  load: async function () {
    const res = (await hillo.get('Complex.php?op=showAllSourceMarkOptions', {}))
      .content
    res.forEach(it => {
      it.kitchenBonDelaySec = (it.kitchenBonDelaySec / 60)
    })
    return res
  }
}

export default IKDataEntity.ModelFactory(entity, config)
